import {DocumentModel} from './document.model';
import {ServiceJobEventModel} from './service-job-event.model';
import {CustomerModel} from './customer.model';
import {ContactModel} from './contact.model';

export class ActionModel {
    public id: number;
    public action_type_id: number; // Model
    public action_priority_id: number; // Model
    public date_created: string;
    public date_scheduled: string;
    public date_completed: string;
    public seq: number;
    public actor: number;
    public actee_map_id: number;
    public comment: string;
    public created_by: number;
    public service_enquiry_id: number;
    public duration: number; // hours
    public sigcap_queue_id: number;
    public ws_job_id: number;
    public parent_action_id: number;
    public celko_lft: number;
    public celko_rgt: number;
    public date_started: string;
    public json_string: string;
    public action_type_id_on_success: number; // TODO check what to do
    public action_type_id_on_failure: number;
    public documentBean: DocumentModel;
    public serviceJobEventBean: ServiceJobEventModel;

    public customerDTO: CustomerModel;
    public contactDTO: ContactModel;
    public status: number;
    public cust_id: number;
    public scontact_id: number;

    public actorName: string;
    public creatorName: string;
    public priorityDesc: string;
    public typeDesc: string;

    [x: string]: any;
}
